import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  tabindex: "0"
}, null, -1);
const _hoisted_2 = {
  tabindex: "-1",
  class: "modal-content custom-account-model-height"
};
const _hoisted_3 = {
  key: 0,
  class: "modal-header",
  style: {
    "padding": "20px 24px"
  }
};
const _hoisted_4 = {
  class: "modal-title"
};
const _hoisted_5 = {
  class: "modal-body",
  style: {
    "padding": "0"
  }
};
const _hoisted_6 = {
  key: 1,
  class: "modal-footer"
};
const _hoisted_7 = {
  key: 2,
  class: "modal-footer",
  style: {
    "padding": "20px 24px"
  }
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  tabindex: "0"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(['modal', 'fade', 'sidebar-account-modal', {
      v2: $props.v2
    }, {
      show: $options.modal
    }, {
      nested: $props.nested
    }, `${$props.custom_class}`]),
    tabindex: "-1",
    role: "dialog",
    style: _normalizeStyle({
      display: $options.modal ? 'block' : 'none'
    }),
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.modal = false, ["self"]))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["modal-dialog", `modal-${$props.size}`])
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [!$props.noHeader ? (_openBlock(), _createElementBlock("header", _hoisted_3, [_createElementVNode("h5", _hoisted_4, _toDisplayString($props.title), 1), !$props.noClose && !$props.v2 ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    type: "button",
    class: "close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onCancel && $options.onCancel(...args))
  }, "×")) : _createCommentVNode("", true), !$props.noClose && $props.v2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "close-button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onCancel && $options.onCancel(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross-new-ui"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")]), !$props.noFooter && !$props.v2 ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [!$props.noCancel ? (_openBlock(), _createBlock(_component_app_button, {
    key: 0,
    variant: "outline-primary",
    onClick: $options.onCancel
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.cancelTitle), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), !$props.noOk ? (_openBlock(), _createBlock(_component_app_button, {
    key: 1,
    loading: $props.okLoading,
    disabled: $props.okDisabled,
    onClick: $options.onOk
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.okTitle), 1)]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$props.noFooter && $props.v2 ? (_openBlock(), _createElementBlock("footer", _hoisted_7, [!$props.noCancel ? (_openBlock(), _createBlock(_component_app_button, {
    key: 0,
    v2: "",
    variant: "outline-secondary",
    version: "btn-modal",
    onClick: $options.onCancel
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.cancelTitle), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), !$props.noOk ? (_openBlock(), _createBlock(_component_app_button, {
    key: 1,
    v2: "",
    variant: "primary",
    version: "btn-modal",
    loading: $props.okLoading,
    disabled: $props.okDisabled,
    onClick: $options.onOk
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.okTitle), 1)]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _hoisted_8], 2)], 6), _createElementVNode("div", {
    class: _normalizeClass(['modal-backdrop', 'fade', {
      v2: $props.v2
    }, {
      show: $options.modal
    }, {
      nested: $props.nested
    }]),
    style: _normalizeStyle({
      display: $options.modal ? 'block' : 'none'
    })
  }, null, 6)], 64);
}